import React from 'react';
import { string, shape } from 'prop-types';

import LabelBuilder from '../../../label-builder/label-builder';

const namespace = 'ui-search-fullsnackbar';

/**
 * TitleSection component
 *
 * @component
 * @param {Object} props
 * @param {Object} props.title - Title configuration
 * @param {string} props.firstText - First text to display
 * @param {string} props.lastText - Last text to display
 * @returns {React.ReactElement|null} The title section component or null if title is not provided
 */

const TitleSection = ({ title, firstText, lastText }) => {
  if (!title) {
    return null;
  }

  return (
    <div className={`${namespace}__top`}>
      {title.first_text && <span className={`${namespace}__preicon`}>{firstText}</span>}
      {title.asset_image && (
        <span className={`${namespace}__icon-label`}>
          <LabelBuilder
            text="{icon}"
            values={[
              {
                icon_id: title.asset_image,
                type: 'ICON',
                key: 'icon',
              },
            ]}
          />
        </span>
      )}
      {title.last_text && <span className={`${namespace}__posticon`}>{lastText}</span>}
    </div>
  );
};

TitleSection.propTypes = {
  firstText: string,
  lastText: string,
  title: shape({
    first_text: string,
    last_text: string,
    asset_image: string,
  }),
};

export default TitleSection;
